var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "overlay-root" },
    _vm._l(_vm.overlays, function(value, key) {
      return _c("ui-overlay", { key: key, attrs: { id: key } })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-11255e36", { render: render, staticRenderFns: staticRenderFns })
  }
}